import axios from 'axios';
const { REACT_APP_API_ENDPOINT } = process.env;

const axiosInstance = axios.create({
  baseURL: `${REACT_APP_API_ENDPOINT}/api/`, 
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' }
});
const apiKey = process.env.REACT_APP_API_KEY;

axiosInstance.interceptors.request.use(
    (config) => {
      if (apiKey) {
        config.headers['X-API-KEY'] = apiKey;
      }
      return config;
    },
    (error) => {
      console.error('Error in request:', error);
      return Promise.reject(error);
    }
  );



export  const fetchEvents = async () => {
    try {
      const response = await axiosInstance.get('tismain/events/');
      return response.data;
    } catch (error) {
      console.error('Error fetching events:', error);
      throw error;
    }
  };



  export const fetchPicture = async (page = 1) => {
    try {
      const response = await axiosInstance.get(`tismain/pictures/random/?page=${page}&page_size=16`);
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching pictures:", error);
      throw error;
    }
  };
  
  export const fetchPicturesByEvent = async (eventName, page = 1) => {
    try {
        const response = await axiosInstance.get(`tismain/event/${eventName}/pictures/?page=${page}&page_size=16`);
        console.log(response.data);
        return {
            results: response.data.results,
            total_pages: response.data.count // Calculate total pages
        };
    } catch (error) {
        console.error(`Error fetching pictures for event ${eventName}:`, error);
        throw error;
    }
};

export const sendEmail = async (emailData) => {
  try {
    console.log(emailData);
    console.log("imhere");
    const response = await axiosInstance.post('tismain/sendmail/', emailData);
    return response.data;
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};

  export const fetchAllEvents = async () => {
    try {
      const response = await axiosInstance.get('tismain/eventsp/');
      return response.data;
    } catch (error) {
      console.error('Error fetching event names:', error);
      throw error;
    }
  };

  export const fetchAllAlumni = async () => {
    try {
      const response = await axiosInstance.get('tismain/displayed-alumni/');
      return response.data;  // Return the fetched alumni data
    } catch (error) {
      console.error('Error fetching alumni:', error);
      throw error;
    }
  };

  export const fetchAlumEvents = async () => {
    try {
      const response = await axiosInstance.get('tismain/alumevents/');
      return response.data;  
    } catch (error) {
      console.error('Error fetching alumni:', error);
      throw error;
    }
  };


  export  const fetchTestimonials = async () => {
    try {
      const response = await axiosInstance.get('tismain/testimonials/');
      return response.data;
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      throw error;
    }
  };

  export const signupalums = async (formData) => {
    try {
      const response = await axiosInstance.post('tismain/alumsignup/', formData, {
        headers: { "Content-Type": "application/json" ,
       "Content-Type": "multipart/form-data", 
        }
      });
      return response; // Return the response from the API
    } catch (error) {
      console.error('Error during signup:', error);
      throw error; // Re-throw the error for the component to handle
    }
  };
  export const loginAlumni = async (loginData) => {
    try {
      const response = await axiosInstance.post("tismain/alumlogin/", loginData);
      const { token, user_id } = response.data;
  
      // Store token & user_id in localStorage
      localStorage.setItem("userToken", token);
      localStorage.setItem("userID", user_id);
  
      return response.data;
    } catch (error) {
      console.error("Error during login:", error);
      throw error;
    }
  };

  export const getAlumniByYear = async (year) => {
    try {
      const response = await axiosInstance.get(`tismain/alumni/${year}/`);
      return response.data;
    } catch (error) {
      console.error("Error fetching alumni data:", error);
      throw error;
    }
  };

export const checkEmail = async (email) => {
  try {
    const response = await axiosInstance.post('api/admission/check_email/', { email });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const confirmPhoneNumber = async (parentId, phoneNumber) => {
  try {
    const response = await axiosInstance.post('api/admission/confirm_phone_number/', { parent_id: parentId, phone_number: phoneNumber });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const resetPassword = async (parentId, newPassword, confirmPassword) => {
  try {
    const response = await axiosInstance.post('api/admission/reset_password/', {
      parent_id: parentId,
      new_password: newPassword,
      confirm_password: confirmPassword
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
